import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { FunctionComponent } from 'react';

import BlockDtDd from '../../ui/definition-list/block-dt-dd';
import DefinitionListHeader from '../../ui/definition-list/definition-list-header';
import IconDetails from '../../ui/icons/details';

const VehicleDetails: FunctionComponent<{
  plate_date: TVehicle['plate_date'];
  vin: TVehicle['vin'];
  engine_code: TVehicle['engine_code'];
  mileage: TVehicle['mileage'];
  mileageCoUk: TVehicle['milageCoUK'];
}> = ({ plate_date, vin, engine_code, mileage, mileageCoUk }) => {
  const { t } = useTranslation();
  return (
    <div className={cx('')}>
      <DefinitionListHeader
        titleClassName={"text-blue-100"}
        title={t('vehicle:vehicle-details')}
      />
      <dl className={cx('grid', 'grid-cols-1 lg:grid-cols-2')}>
        <BlockDtDd
          span
          dt={t('vehicle:details.plate-year')}
          dd={plate_date || '-'}
        />
        <BlockDtDd span dt={t('vehicle:details.vin')} dd={vin || '-'} />
        <BlockDtDd
          span
          dt={t('vehicle:details.engine_code')}
          dd={engine_code || '-'}
        />
        <BlockDtDd
          span
          dt={
            process.env.NEXT_PUBLIC_HOST?.includes('.co.uk')
              ? t('vehicle:details.miles')
              : t('vehicle:details.km')
          }
          dd={
            mileageCoUk && mileageCoUk > 0
              ? mileageCoUk.toFixed(0).toString()
              : mileage || '-'
          }
        />
      </dl>
    </div>
  );
};

export default VehicleDetails;
